/*
 * @Description: 营销活动确定订单
 * @Author: kayvor
 * @Date: 2020-09-01 11:55:28
 * @LastEditors: kayvor
 * @LastEditTime: 2020-09-01 11:56:16
 */

import ajax from '../http/ajax'

// 获取营销活动详情数据
export const getOrderInfo = params => {
    return ajax.get('getOrderInfo', params)
}
